import { render } from "./FunFacts.vue?vue&type=template&id=eac27310&scoped=true"
import script from "./FunFacts.vue?vue&type=script&lang=js"
export * from "./FunFacts.vue?vue&type=script&lang=js"

import "./FunFacts.vue?vue&type=style&index=0&id=eac27310&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eac27310"]])

export default __exports__